import moment from 'moment';

export const showDiffTsInDisplay = ts => {
  const date = moment(ts * 1000);
  const london = date.clone().utc();

  if (london.date() === date.date()) return '';
  return date.utcOffset() > london.utcOffset() ? '+ 1' : '- 1';
};
